import RoutesMap from 'route_control/RouteControl'
import { ResourceList, ResourceDetails, BookingList, AdminAmenities } from 'pages/amenities'

const AmenitiesRoute = () => {
    return [
        {
            path: RoutesMap.RESOURCE_LIST.path,
            element: <ResourceList />,
        },
        {
            path: RoutesMap.RESOURCE_DETAILS.path,
            element: <ResourceDetails />,
        },
        {
            path: RoutesMap.BOOKING_LIST.path,
            element: <BookingList />,
        },
        {
            path: RoutesMap.ADMIN_AMENITIES.path,
            element: <AdminAmenities />,
        },
    ]
}

export default AmenitiesRoute;